import {ROLES_MATRIX} from 'core/constants/roleMatrix';

import {$userRoles} from 'models/auth';

import {UserPermissionValue, UserRoles} from 'types';

export const findPermissions = (role?: UserRoles) => (role ? ROLES_MATRIX[role] : []);

export const hasAccess = (
    rolePermissions?: UserPermissionValue[],
    required?: UserPermissionValue[],
) => {
    if (!rolePermissions?.length) return false;
    if (!required || required.length === 0) return true;
    return required.some((r) => rolePermissions.includes(r));
};

export const hasAccessByRoles = (allowedRoles?: UserRoles[]) => {
    if (!allowedRoles) return false;
    const userRoles = $userRoles.getState();

    if (!userRoles?.length) return false;

    const allowByUserRoles = allowedRoles?.some((role) => userRoles.includes(role));

    return allowByUserRoles;
};
